const participant = 'participant';
const thirdParty = 'third_party';
const henryFordHealth = 'henry_ford_health';

export const reportFor = { participant, thirdParty, henryFordHealth };
